import axios from 'axios';

const CALENDLY_API_KEY = 'eyJraWQiOiIxY2UxZTEzNjE3ZGNmNzY2YjNjZWJjY2Y4ZGM1YmFmYThhNjVlNjg0MDIzZjdjMzJiZTgzNDliMjM4MDEzNWI0IiwidHlwIjoiUEFUIiwiYWxnIjoiRVMyNTYifQ.eyJpc3MiOiJodHRwczovL2F1dGguY2FsZW5kbHkuY29tIiwiaWF0IjoxNzQ0NDUwNDc0LCJqdGkiOiI4NGIxZmVlYi1mOTYxLTRhYTMtOTAyZi0yNzg0Mzc3ODhjNmEiLCJ1c2VyX3V1aWQiOiI3MjM4NDA4Ny0yZjY1LTRmNTgtYmM4MC05NTI5NDI0MDljYjEifQ.ik9w1uHLVDM5pViFAzuoJR0Lt4gV3DYCy-ifVlNc3tmdXA75yqRJDvxBbUgnOSN_M-6cBPcorB3oIX1NjED-HA';
// const CALENDLY_USER_URI = "https://api.calendly.com/users/72384087-2f65-4f58-bc80-952942409cb1";
// const CALENDLY_USER_URI = "https://api.calendly.com/users/me"; 
const CALENDLY_USER_ID = "72384087-2f65-4f58-bc80-952942409cb1";

export const scheduleCalendlyEvent = async (userData, selectedSlot) => {
    try {
      // 1. First get all event types
      const eventTypesResponse = await axios.get(
        `https://api.calendly.com/event_types`,
        {
          headers: {
            'Authorization': `Bearer ${CALENDLY_API_KEY}`,
            'Content-Type': 'application/json'
          },
          params: {
            user: `https://api.calendly.com/users/${CALENDLY_USER_ID}`
          }
        }
      );
  
      // Find the group event (or first available event)
      const groupEvent = eventTypesResponse.data.collection.find(
        event => event.kind === "group" && event.active
      ) || eventTypesResponse.data.collection[0];
  
      if (!groupEvent) {
        throw new Error("No active events found in your Calendly account");
      }
  
      // 2. Create the scheduling link (alternative approach)
      const schedulingResponse = await axios.post(
        `https://api.calendly.com/scheduling_links`,
        {
          max_event_count: 1,
          owner: groupEvent.uri,
          owner_type: "EventType"
        },
        {
          headers: {
            'Authorization': `Bearer ${CALENDLY_API_KEY}`,
            'Content-Type': 'application/json'
          }
        }
      );
  
      return {
        success: true,
        bookingUrl: schedulingResponse.data.resource.booking_url,
        eventType: groupEvent.name
      };
  
    } catch (error) {
      console.error("Full API error:", {
        status: error.response?.status,
        data: error.response?.data,
        config: error.config
      });
      
      throw new Error(
        error.response?.data?.message || 
        error.message || 
        "Failed to schedule event. Please try again later."
      );
    }
  };